module.exports = __webpack_public_path__ + "html/wave-header_d5a58d020145b7055b0833d707c47141.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/wave-header.html
// module id = eXN9
// module chunks = 153